import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 8px;
`;

export const LeafLink = styled(Link)`
  text-decoration: none;
`;
